import { render, staticRenderFns } from "./ChallengeRankingButton.vue?vue&type=template&id=2830906a&scoped=true&"
import script from "./ChallengeRankingButton.vue?vue&type=script&lang=js&"
export * from "./ChallengeRankingButton.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeRankingButton.vue?vue&type=style&index=0&id=2830906a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2830906a",
  null
  
)

export default component.exports